import "./Casebanner.css";

function Casebanner({ image, heading, intro, role, tools }) {
  const backend = process.env.REACT_APP_BACKEND_LINK;
  const imageUrl = image?.startsWith("http") ? image : `${backend.replace(/\/$/, "")}${image}`;

  return (
    <section id="case-banner">
      <div
        className="case-banner-hero"
        style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : undefined }}
      >
        <div className="case-banner-inner">
          <div className="case-banner-header">
            <h1 className="case-banner-title">{heading}</h1>
            {intro && <p className="case-banner-intro">{intro}</p>}
          </div>
          {(role || tools) && (
            <div className="case-banner-meta">
              {role && <p className="case-banner-meta-line">Role: {role}</p>}
              {tools && <p className="case-banner-meta-line">Tools: {tools}</p>}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Casebanner;
